import React, { useState, useEffect, useContext } from 'react';
import { AddToCartContext } from './AddToCartContext';
import { AppContext } from '../../../AppContext';
import { getStoreId, getProductPricePrefixAsync, getProductButtonColorsAsync, getProductButtonFields } from '../../../utils/StoreConfigManager';
import { CartRemoveButtonClicked } from '../../../utils/Analytics.js';

const storeId = getStoreId();
const CART_SESSION_STORAGE_KEY = 'cartList';

// TODO: Add backend cart saving support, possibly by storing UUIDs + cookies
// Add To Cart Context provides modal context with access to add/remove cart functionality
// Context also used in top level UI to create a dropdown add to cart menu
const AddToCartContextComponent = (props) => {
    const [cartList, setCartList] = useState([]);
    const [itemCount, setItemCount] = useState(0);
    const [cartButtonHidden, setCartButtonHidden] = useState(true);
    const [pricePrefix, setPricePrefix] = useState('$');
    const [colors, setColors] = useState();
    const [buttonFields, setButtonFields] = useState();
    const [shopifyCheckoutId, setShopifyCheckoutId] = useState(null);
    const [shopifyWebUrl, setShopifyWebUrl] = useState("");
    const [cartSubTotal,setCartSubTotal] = useState(0);

    const { shopifyClient } = useContext(AppContext);

    // TODO: Currently not tied to any functionality. To be used in dropdown cart
    // Load saved cookie if ID stored in cookie matches ID of current store
    useEffect(() => {
        (async () => {
            setPricePrefix(await getProductPricePrefixAsync());
            setColors(await getProductButtonColorsAsync());
            setButtonFields(await getProductButtonFields());
        })()
        const existingSessionCart = sessionStorage.getItem(CART_SESSION_STORAGE_KEY);
        if (existingSessionCart) {
            const sessionCartList = JSON.parse(existingSessionCart);
            if (sessionCartList['storeId'] === storeId) {
                const savedList = sessionCartList['cartList'];
                const shopifyCheckoutId = sessionCartList['checkoutId'];
                const shopifyWebUrl = sessionCartList['shopifyWebUrl']
                const subTotal = sessionCartList['subTotal']
                setShopifyCheckoutId(shopifyCheckoutId);
                setShopifyWebUrl(shopifyWebUrl);
                setCartList(savedList);
                setCartSubTotal(subTotal)
            }
        }
    }, [])

    // Saves add to cart list in a cookie
    useEffect(() => {
        if (cartList.length > 0) {
            setSessionCart(shopifyWebUrl);
        }
        let cartCount = 0;
        cartList.forEach(element => {
             cartCount +=  element.QUANTITY;
        });
        setItemCount(cartCount);
    }, [cartList])

    const setSessionCart = (webUrl) => {
        const sessionCartObject = {
            storeId: storeId,
            cartList: cartList,
            checkoutId: shopifyCheckoutId,
            webUrl: webUrl,
            subTotal:cartSubTotal,
            cartCount:itemCount
        }
        const sessionCartString = JSON.stringify(sessionCartObject);
        sessionStorage.setItem(CART_SESSION_STORAGE_KEY, sessionCartString);
    }

    const getLineItemId = (variantName, lineItemsData) => {
        for (const lineItem of lineItemsData) {
            if (variantName === lineItem.title) {
                return lineItem.id;
            }
        }
    }

    const setToCartSubTotal = () => {

    }

    const addToCart = (item) => {
        // create checkout on first item added to cart
        const existingCart = sessionStorage.getItem(CART_SESSION_STORAGE_KEY);
        if (existingCart) {
            shopifyClient.addItemToCart(shopifyCheckoutId, item.VARIANT_ID, item.QUANTITY).then(checkout => {
                const lineItemId = getLineItemId(item.TITLE, checkout.lineItems);
                setShopifyWebUrl(checkout.webUrl);
                var productIndex = cartList.findIndex(element => element.VARIANT_ID === item.VARIANT_ID);
                if(productIndex !== -1){
                    var updatedCartList = cartList;
                    // updatedCartList[productIndex].QUANTITY = updatedCartList[productIndex].QUANTITY+item.QUANTITY;
                    updatedCartList[productIndex].QUANTITY += item.QUANTITY;
                    updatedCartList[productIndex].DOWNSIZED_THUMBNAIL = item.DOWNSIZED_THUMBNAIL;
                    setCartList([...cartList]);
                } else {
                    setCartList([...cartList, { ...item, LINE_ITEM_ID: lineItemId }])
                }
            });
        } else {
            shopifyClient.createCart().then(checkout => {
                setShopifyCheckoutId(checkout.id);
                shopifyClient.addItemToCart(checkout.id, item.VARIANT_ID, item.QUANTITY).then(checkout => {
                    const lineItemId = getLineItemId(item.TITLE, checkout.lineItems);
                    setShopifyWebUrl(checkout.webUrl);
                    var productIndex = cartList.findIndex(element => element.VARIANT_ID === item.VARIANT_ID);
                    if(productIndex !== -1){
                        var updatedCartList = cartList;
                        // updatedCartList[productIndex].QUANTITY = updatedCartList[productIndex].QUANTITY+item.QUANTITY;
                        updatedCartList[productIndex].QUANTITY = item.QUANTITY;
                        setCartList([...cartList]);
                    } else {
                        setCartList([...cartList, { ...item, LINE_ITEM_ID: lineItemId }])
                    }
                })
            })
        }
    }

    const removeFromCart = (itemTitleAndSize) => {
        const updatedCartList = [];
        cartList.forEach(cartItem => {
            if (cartItem.TITLE_AND_SIZE !== itemTitleAndSize) {
                updatedCartList.push(cartItem);
            } else {
                shopifyClient.removeItemFromCart(shopifyCheckoutId, cartItem.LINE_ITEM_ID).then(checkout => {
                    console.log(checkout)
                });
            }
        })
        setCartList(updatedCartList);
    }

    const updateFromCart = (itemTitleAndSize) => {
        const updatedCartList = [];
        cartList.forEach(cartItem => {
            if (cartItem.TITLE_AND_SIZE !== itemTitleAndSize) {
                updatedCartList.push(cartItem);
            } else {
                cartItem.QUANTITY = cartItem.QUANTITY-1;
                updatedCartList.push(cartItem);
                shopifyClient.updateItemFromCart(shopifyCheckoutId, cartItem.LINE_ITEM_ID, cartItem.QUANTITY).then(checkout => {
                    console.log(checkout)
                });
            }
        })
        setCartList(updatedCartList);
    }

    const resetCartList = () => {
        setCartList([]);
    }

    const contextValue = {
        cartList,
        itemCount,
        addToCart,
        removeFromCart,
        updateFromCart,
        resetCartList,
        cartButtonHidden,
        setCartButtonHidden,
        pricePrefix,
        colors,
        buttonFields,
        shopifyCheckoutId,
        shopifyWebUrl,
        CART_SESSION_STORAGE_KEY,
        cartSubTotal,
        setCartSubTotal,
        setToCartSubTotal
    }

    return (
        <AddToCartContext.Provider value={contextValue}>
            {props.children}
        </AddToCartContext.Provider>
    )
}

export default AddToCartContextComponent;
